import gql from 'graphql-tag'
export default gql`query gradingCurveQuery($id: Int!) {
  gradingCurve(id: $id) {
    code
    description
    type
    sieveSteps {
      min
      max
      maxAlt
      sieveSize {
        code
        size
        id
      }
    }
    id
    dMax
  }
}`